// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__pxvbC","label":"Labeled_label__Oq0ZV","divider":"Labeled_divider__25MKH"};